export const PERIODS = [
    { value: "years" },
    { value: "quarters" },
    { value: "months" },
    { value: "weeks" },
    { value: "days" }
];